import moment from "moment";
export default safe => {
  console.log(safe); //vue的this对象
  return {
    lazy: true,
    tip: false,
    simplePage: true,
    searchShow: false,
    // searchMenuSpan: 6,
    tree: true,
    border: true,
    /** 表格索引 */
    index: true,
    /** 索引说明 */
    indexLabel: "No",
    /** 表格搜索显隐按钮 */
    searchShowBtn: false,
    /** 是否启用功能按钮 */
    searchIcon: false,
    searchIndex: 0,
    /** 表格查看按钮 */
    viewBtn: false,
    /** 表格新增按钮 */
    addBtn: false,
    /** 表格删除按钮 */
    delBtn: false,
    /** 表格修改按钮 */
    editBtn: false,
    /** 表格搜索按钮 */
    searchBtn: false,
    /** 表格清空按钮 */
    emptyBtn: false,
    /** 表格列操作按钮 */
    columnBtn: false,
    /** 表格刷新数据按钮 */
    refreshBtn: false,
    /** 开启拖拽功能 */
    sortable: true,
    // dragHandler: true,
    rowSort: true,
    columnSort: true,
    menuWidth: 240,
    column: [

      {
        label: "分集序号",
        prop: "num"
      },
      {
        label: "乐播分集Id",
        prop: "id"
      },
      {
        label: "分集名称",
        prop: "name",
        slot: true
      },

      {
        label: "是否解锁",
        prop: "episodeMovie", //feeMode
        slot: true
      },
      {
        label: "分集状态",
        prop: "status",
        dicData: [
          {
            label: "上线",
            value: 1
          },
          {
            label: "下线",
            value: 0
          }
        ]
      },
      {
        label: "时长",
        prop: "duration",
        formatter: val => {
          const duration = moment.duration(val.duration, "seconds");
          return (
            duration
              .hours()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .minutes()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .seconds()
              .toString()
              .padStart(2, "0")
          );
        }
      },
      {
        label: "试看时长",
        prop: "clipDuration	",
        formatter: val => {
          const duration = moment.duration(val.clipDuration, "seconds");
          return (
            duration
              .hours()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .minutes()
              .toString()
              .padStart(2, "0") +
            ":" +
            duration
              .seconds()
              .toString()
              .padStart(2, "0")
          );
        }
      },
      {
        label: "更新时间",
        prop: "updateTime"
      },
    ]
  };
};
